import PropTypes from 'prop-types';

export const propTypes = {
  serialNumber: PropTypes.string,
};

export const defaultProps = {
  serialNumber: undefined,
};
